import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_COMPLEX = graphql(/* GraphQL */ `
  query IntakeRequestComplex($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        requestDescription {
          id
          text
        }
        request {
          accountingAreaId
          organizationId
          commodityGroupId
          currency
          budget
          id
          costCenterId
          deliveryLocationId
          lineItems {
            id
            sequence
            position
            title
            description
            commodityGroupId
            quantity
            earlyDeliveryAt
            lateDeliveryAt
            expectedPricePerUnit
            unitId
          }
        }
      }
    }
  }
`);
